import React from 'react'
import PropTypes from 'prop-types'
import { CardCustomized, CardHeaderCustomized } from './style'

const CardWithTitle = ({ children, cardTitle }) => {
    return (
        <CardCustomized small className="mb-4">
            <CardHeaderCustomized className={'border-bottom'}>{cardTitle}</CardHeaderCustomized>
            {children}
        </CardCustomized>
    )
}

CardWithTitle.propTypes = {
    children: PropTypes.element,
    cardTitle: PropTypes.string,
}

export default CardWithTitle
